export * from './dynamic-page.directive';



// WEBPACK FOOTER //
// ./src/app/directives/dynamic-page/index.ts